/* eslint-disable import/no-anonymous-default-export */
export default {
  contacts:
    "Needs contacts permission, please go to settings and turn on permissions manually.",
  camera:
    "Needs camera permission, please go to settings and turn on permissions manually.",
  gallery:
    "Needs gallery permission, please go to settings and turn on permissions manually.",
  storage:
    "Needs storage permission, please go to settings and turn on permissions manually.",
  microphone:
    "Needs microphone permission, please go to settings and turn on permissions manually.",
  microphone_storage:
    "Needs microphone and storage permission, please go to settings and turn on permissions manually.",
  location:
    "Needs location permission, please go to settings and turn on permissions manually.",
};
